import { render } from "./NavbarItem.vue?vue&type=template&id=5309f21a"
import script from "./NavbarItem.vue?vue&type=script&lang=js"
export * from "./NavbarItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Navigation/NavbarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5309f21a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5309f21a', __exports__)) {
    api.reload('5309f21a', __exports__)
  }
  
  module.hot.accept("./NavbarItem.vue?vue&type=template&id=5309f21a", () => {
    api.rerender('5309f21a', render)
  })

}


export default __exports__